import {
    createSlice,
    createEntityAdapter,
} from '@reduxjs/toolkit';
import {
    moreGamesUpdate,
} from '~SpectateStore/actions/moreGamesActions';
import { storeCleanup } from '~SpectateStore/actions/storeCleanupActions';


export const moreGamesAdapter = createEntityAdapter();

const moreGamesSlice = createSlice({
    name: 'moreGames',
    initialState: moreGamesAdapter.getInitialState(),
    extraReducers: (builder) => {
        builder
        .addCase(
            moreGamesUpdate,
            (state, { payload : { moreGamesPointers } }) => {
                moreGamesAdapter.setOne(state, moreGamesPointers);
            },
        )
        .addCase(
            storeCleanup,
            (state, { payload : { eventIds } }) => {
                moreGamesAdapter.removeMany(state, eventIds);
            },
        );
    },
});

export default moreGamesSlice.reducer;
